import React from "react";
import logo from "../../../assets/logo.svg";

const Logo = () => {
  return <img src={logo} alt="Lemken" width="180" />;
};

export default Logo;
